import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../context/AuthContext';
import { User } from '../../types/admin';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import Box from '../../components/Common/Box';

const TenantUsers: React.FC = () => {
  const { token } = useAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_URL}/tenant/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          // Ensure data is an array before setting
          setUsers(Array.isArray(data) ? data : []);
        } else {
          console.error('Error fetching tenant users: HTTP', response.status);
          setUsers([]);
        }
      } catch (error) {
        console.error('Error fetching tenant users:', error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token]);

  return (
    <SiteLayout>
      <Header icon='group' title='Utilisateurs du Tenant' />
      <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ flex: 1 }}>
            {/* Search or other controls could go here */}
          </div>
          <button className="btn btn-primary" onClick={() => alert('Invite User functionality to be implemented')}>
            + Inviter Utilisateur
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
            Chargement...
          </div>
        ) : (
          <Box>
            <div className="admin-table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Utilisateur</th>
                    <th>Rôle</th>
                    <th className="center">Statut</th>
                    <th className="center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{
                            width: '32px', height: '32px', borderRadius: '50%',
                            background: '#e2e8f0', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontWeight: 'bold', color: '#64748b'
                          }}>
                            {(user.full_name || user.email || '?').charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <div style={{ fontWeight: '500' }}>{user.full_name || 'Sans nom'}</div>
                            <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{user.email}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="badge badge-info">
                          {user.role?.name || 'N/A'}
                        </span>
                      </td>
                      <td className="center">
                        <span className={`badge ${user.is_active ? 'badge-success' : 'badge-danger'}`}>
                          {user.is_active ? 'Actif' : 'Inactif'}
                        </span>
                      </td>
                      <td className="center">
                        <button className="action-btn" title="Edit">
                          <i className="material-icons">edit</i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Box>
        )}
      </div>
    </SiteLayout>
  );
};

export default TenantUsers;

